export default __webpack_public_path__ + "static/media/news85.116c10d5.jpg";